import {AfterViewInit, Component} from '@angular/core';
import {FooterAuthService} from "./service/footer-auth.service";

@Component({
  selector: 'app-footer-auth',
  templateUrl: './footer-auth.component.html',
  styleUrls: ['./footer-auth.component.scss']
})
export class FooterAuthComponent {
  constructor(public footerAuthService: FooterAuthService) {}
}
